module.exports = __webpack_public_path__ + "static/img/guide_step_2.df78bd7a.png";